module.exports = __webpack_public_path__ + "assets/img/bj3.d3afb6bd.png";